import { Stack, StackProps } from "@mui/material";
import { APP_IMGS } from "Assets/images";

type Props = StackProps & {
  miniSize?: boolean;
};

const FreshdiLoading = ({ miniSize = false, ...props }: Props) => {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      height={miniSize ? "fit-content" : "100%"}
      minHeight={miniSize ? "200px!important" : "85vh"}
      {...props}
    >
      <img src={APP_IMGS.common.desktop["freshdiLoading"]} alt="icon" loading="lazy"/>
    </Stack>
  );
};

export default FreshdiLoading;
